import { createReducer } from '@reduxjs/toolkit'
import { TourModelT } from 'types/model'
import { receiveTourModel } from 'model/actions'

const initialState = null as TourModelT | null

const reducer = createReducer(initialState, builder => {
  builder.addCase(receiveTourModel, (state, action) => action.payload)
})

export default reducer
